import { userAxios } from '../index'

/**
 * Retrieves paginated list of admin-agent relations.
 */
export const listAdminAgentUsers = async (params = {}) =>
  userAxios.get('/admin-agent-user', { params }).then(response => response.data)

/**
 * Retrieves the detail for a specific admin with its agents.
 */
export const getAdminAgentUserByAdmin = async adminId =>
  userAxios.get(`/admin-agent-user/${adminId}`).then(response => response.data)

/**
 * Creates a new admin-agent relation.
 */
export const createAdminAgentUser = async payload =>
  userAxios.post('/admin-agent-user', payload).then(response => response.data)

/**
 * Updates an existing admin-agent relation.
 */
export const updateAdminAgentUser = async (relationId, payload) =>
  userAxios
    .put(`/admin-agent-user/${relationId}`, payload)
    .then(response => response.data)

/**
 * Deletes an existing admin-agent relation.
 */
export const deleteAdminAgentUser = async relationId =>
  userAxios.delete(`/admin-agent-user/${relationId}`).then(response => response.data)

/**
 * Retrieves catalog of agents available to be linked.
 */
export const listAgentsCatalog = async () =>
  userAxios.get('/users/by-agent').then(response => response.data)

/**
 * Retrieves catalog of admins specifically for select controls.
 */
export const listAdminsCatalog = async params =>
  userAxios.get('/get-admin-agent-user', { params }).then(response => response.data)

export default {
  listAdminAgentUsers,
  getAdminAgentUserByAdmin,
  createAdminAgentUser,
  updateAdminAgentUser,
  deleteAdminAgentUser,
  listAgentsCatalog,
  listAdminsCatalog,
}
